import {fetchGet} from "../libs/reqCommon";
import {platformtoarr } from "@/libs/index";

const state={
    bmcCampaigntype:{
        singleLinkNum:null,
        plateform:[],
        havesingleLinkNum:null,
        itemIds:'11061298097',
        step:0,
    },
    moniotorLinkList:{
        tableData:[],
        totalPage:0,
        search:{
            pageNo:1,
            pageSize:10
        }
    },
    monitorChartsColor:["#3aa0ff", "#975fe4",'#36cbcb','#4dcb73','#fad337','#f2637b','#ff9f7f','#e7bcf3','#9fe6b8','#9d96f5'],
    wechatNoticeList:[],
    addLinkOpenids:'',
    firstin:false,

}
const getters={
    bmcCampaigntype:state=>{
        return state.bmcCampaigntype
    },
    monitorTabaData:state=>{
        return state.bmcCampaigntype.monitorTabaData
    },
    campaigntypeitemIds:state=>{
        return state.bmcCampaigntype.itemIds
    },
    moniotorLinkList:state=>{
        return state.moniotorLinkList
    },
    monitorChartsColor:state=>{
        return state.monitorChartsColor
    },
    wechatNoticeList:state=> {
        return state.wechatNoticeList
    },
    addLinkOpenids:state=> {
        return state.addLinkOpenids
    },

}
const mutations={
    changebmcCampaigntype(state,params){
        state.bmcCampaigntype.singleLinkNum=params.singleLinkNum
        state.bmcCampaigntype.plateform=params.plateform
    },
    changehavesingleLinkNum(state,params){
        state.bmcCampaigntype.havesingleLinkNum=params
    },
    changeitemIds(state,params){
        state.bmcCampaigntype.itemIds=params
    },
    chanstep(state,params){
        state.bmcCampaigntype.step=params
    },
    changeLinkList(state,params){
        state.moniotorLinkList.tableData=params.content
        state.moniotorLinkList.totalPage=params.totalElements
    },
    chanegMoniotorSearch(state,params){
        state.moniotorLinkList.search=params
    },
    setNoticeList(state, payload) {
        state.wechatNoticeList = payload;
    },
    changeAddLinkOpenids(state, payload) {
        console.log(payload)
        state.addLinkOpenids = payload;
    },
    summarizeItemcount(state, payload){
        state.firstin = payload===0?true:false;
        console.log(state.itemcount)
    }

}
const actions={
    reqselectbmcCampaigntype ( { commit }){
        fetchGet("/hcm/cus/selectbmcSetting").then(res => {
            if (res.status === "10000") {
                let obj={
                    singleLinkNum:Number(res.data.singlelinkNumber),
                    plateform:platformtoarr(res.data.singlelinkPlatform.split(','))
                }
                commit('changebmcCampaigntype',obj)
            }
        })
    },
    reqmonitorLinkCount( { commit }){
        fetchGet("/hcm/monitorLink/monitorLinkCount").then(res=>{
            if (res.status === "10000"){
                commit('changehavesingleLinkNum',Number(res.data))
            }
        })
    },
    reqgetMonitorItemList({commit},data){
        return new Promise((r,j)=>{
            fetchGet("hcm/monitorLink/getMonitorItemList", data).then(res => {
                if (res.status === "10000") {
                  commit('changeLinkList',res.data)
                  r(res)
                }
              });
        })

    },
    monitorNoticeList({commit}){
        return new Promise((r,j)=>{
            fetchGet("/hcm/hcmNewMonitorProduct/monitorNoticeList").then(res=>{
                if(res.status === '10000') {
                    commit('setNoticeList', res.data);
                    r()
                }
            })
        })
    },


}
export default {
    state,
    getters,
    mutations,
    actions
  }
